import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <section class="field">
  {{#if this.category.is_special}}
    {{#if this.category.isUncategorizedCategory}}
      <p class="warning">{{i18n "category.uncategorized_security_warning"}}</p>
    {{else}}
      <p class="warning">{{i18n "category.special_warning"}}</p>
    {{/if}}
  {{/if}}

  {{#unless this.category.is_special}}
    <div class="category-permissions-table">
      <div class="permission-row row-header">
        <span class="group-name">{{i18n "category.permissions.group"}}</span>
        <span class="options">
          <span class="cell">{{i18n "category.permissions.see"}}</span>
          <span class="cell">{{i18n "category.permissions.reply"}}</span>
          <span class="cell">{{i18n "category.permissions.create"}}</span>
        </span>
      </div>
      {{#each this.category.permissions as |p|}}
        <CategoryPermissionRow
          @group_name={{p.group_name}}
          @type={{p.permission_type}}
          @category={{this.category}}
          @everyonePermission={{this.everyonePermission}}
        />
      {{/each}}

      {{#unless this.category.permissions}}
        <div class="permission-row row-empty">
          {{i18n "category.permissions.no_groups_selected"}}
        </div>
      {{/unless}}

      {{#if this.category.availableGroups}}
        <div class="add-group">
          <span class="group-name">
            <ComboBox
              @content={{this.category.availableGroups}}
              @onChange={{action "onSelectGroup"}}
              @value={{null}}
              @valueProperty={{null}}
              @nameProperty={{null}}
              @options={{hash none="category.security_add_group"}}
              class="available-groups"
            />
          </span>
        </div>
      {{/if}}
    </div>

    {{#if this.everyoneGrantedFull}}
      <p class="warning">{{i18n "category.permissions.everyone_has_access"}}</p>
    {{/if}}
  {{/unless}}
</section>

<section>
  <PluginOutlet
    @name="category-custom-security"
    @outletArgs={{hash category=this.category}}
  />
</section>
*/
{
  "id": "mPtc5+WY",
  "block": "[[[10,\"section\"],[14,0,\"field\"],[12],[1,\"\\n\"],[41,[30,0,[\"category\",\"is_special\"]],[[[41,[30,0,[\"category\",\"isUncategorizedCategory\"]],[[[1,\"      \"],[10,2],[14,0,\"warning\"],[12],[1,[28,[35,1],[\"category.uncategorized_security_warning\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,2],[14,0,\"warning\"],[12],[1,[28,[35,1],[\"category.special_warning\"],null]],[13],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[51,[30,0,[\"category\",\"is_special\"]]],[[[1,\"    \"],[10,0],[14,0,\"category-permissions-table\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"permission-row row-header\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"group-name\"],[12],[1,[28,[35,1],[\"category.permissions.group\"],null]],[13],[1,\"\\n        \"],[10,1],[14,0,\"options\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"cell\"],[12],[1,[28,[35,1],[\"category.permissions.see\"],null]],[13],[1,\"\\n          \"],[10,1],[14,0,\"cell\"],[12],[1,[28,[35,1],[\"category.permissions.reply\"],null]],[13],[1,\"\\n          \"],[10,1],[14,0,\"cell\"],[12],[1,[28,[35,1],[\"category.permissions.create\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"category\",\"permissions\"]]],null]],null],null,[[[1,\"        \"],[8,[39,5],null,[[\"@group_name\",\"@type\",\"@category\",\"@everyonePermission\"],[[30,1,[\"group_name\"]],[30,1,[\"permission_type\"]],[30,0,[\"category\"]],[30,0,[\"everyonePermission\"]]]],null],[1,\"\\n\"]],[1]],null],[1,\"\\n\"],[41,[51,[30,0,[\"category\",\"permissions\"]]],[[[1,\"        \"],[10,0],[14,0,\"permission-row row-empty\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"category.permissions.no_groups_selected\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"category\",\"availableGroups\"]],[[[1,\"        \"],[10,0],[14,0,\"add-group\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"group-name\"],[12],[1,\"\\n            \"],[8,[39,6],[[24,0,\"available-groups\"]],[[\"@content\",\"@onChange\",\"@value\",\"@valueProperty\",\"@nameProperty\",\"@options\"],[[30,0,[\"category\",\"availableGroups\"]],[28,[37,7],[[30,0],\"onSelectGroup\"],null],null,null,null,[28,[37,8],null,[[\"none\"],[\"category.security_add_group\"]]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"everyoneGrantedFull\"]],[[[1,\"      \"],[10,2],[14,0,\"warning\"],[12],[1,[28,[35,1],[\"category.permissions.everyone_has_access\"],null]],[13],[1,\"\\n\"]],[]],null]],[]],null],[13],[1,\"\\n\\n\"],[10,\"section\"],[12],[1,\"\\n  \"],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"category-custom-security\",[28,[37,8],null,[[\"category\"],[[30,0,[\"category\"]]]]]]],null],[1,\"\\n\"],[13]],[\"p\"],false,[\"if\",\"i18n\",\"unless\",\"each\",\"-track-array\",\"category-permission-row\",\"combo-box\",\"action\",\"hash\",\"plugin-outlet\"]]",
  "moduleName": "discourse/components/edit-category-security.hbs",
  "isStrictMode": false
});